import "./homeTransformCTA.css";

const HomeTransformCTA = () => {
  return (
    <section className="homeTransformCTA">
      <div className="homeTransformCTAContent fx-cl fx-jc space2">
        <div className="fx-cl space1">
          <h2 className="fs8 lh1 fw400 cw">
            Ready to Turn Your Operations Into a Competitive Advantage?
          </h2>

          <p className="fs4 lh3 cw">
            From keeping stock accurate to managing sales, teams, and locations,
            Universe Inventory gives you the visibility and control you need to
            run your business efficiently, confidently and from everywhere you
            are.
          </p>
        </div>

        <div className="fx-ac space2">
          <button className="homeTransformCTAPrimary">
            Register now in few steps
          </button>

          <button className="homeTransformCTASecondary">
            Explore Enterprise
          </button>
        </div>
      </div>
    </section>
  );
};

export default HomeTransformCTA;
